import React from 'react'
import styled from 'styled-components'
import ImagePlaceholder from 'core/components/image-placeholder'

const ImagePlaceholderWrapper = styled.div`
  height: 250px;
  width: 100%;
`

const ImagePlaceholderWrapperComponent = () => (
  <ImagePlaceholderWrapper>
    <ImagePlaceholder data-test="component-stock-vehicles-list-vehicleItem-ImagePlaceholder" />
  </ImagePlaceholderWrapper>
)

export default ImagePlaceholderWrapperComponent
